var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.359 4.19528C26.4349 3.83965 26.3911 3.46892 26.2345 3.14072C26.078 2.81252 25.8174 2.54524 25.4932 2.38041C25.1691 2.21559 24.7996 2.16245 24.4422 2.22927C24.0847 2.29608 23.7594 2.4791 23.5166 2.74988L4.81665 23.6499C4.6043 23.8873 4.46521 24.1811 4.41617 24.4958C4.36712 24.8105 4.41021 25.1327 4.54024 25.4235C4.67027 25.7142 4.88168 25.9612 5.14895 26.1344C5.41622 26.3077 5.72793 26.3999 6.04645 26.3999H20.5048L17.6338 39.8045C17.558 40.1601 17.6018 40.5308 17.7584 40.8591C17.9149 41.1872 18.1755 41.4545 18.4997 41.6194C18.8238 41.7842 19.1933 41.8373 19.5507 41.7705C19.9082 41.7037 20.2335 41.5207 20.4762 41.2499L39.1763 20.3499C39.3886 20.1125 39.5277 19.8187 39.5767 19.504C39.6258 19.1892 39.5827 18.8671 39.4527 18.5763C39.3226 18.2855 39.1112 18.0386 38.8439 17.8653C38.5767 17.6921 38.265 17.5999 37.9464 17.5999H23.4881L26.359 4.19528Z",
    fill: "url(#paint0_linear_1665_16137)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1665_16137",
    x1: 21.9964,
    y1: 2.20117,
    x2: 21.9964,
    y2: 41.7986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#985AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBoost);
export default __webpack_public_path__ + "static/media/purpleBoost.5e242a4b60a38e53c95c896c3daee226.svg";
export { ForwardRef as ReactComponent };